import moment from 'moment';


const startOfDay = (m) => m.clone().startOf('day');

export const tonightRange = (now = moment()) => {
  const arrival = startOfDay(now);
  return { arrivalDate: arrival, departureDate: arrival.clone().add(1, 'day') };
};

export const tomorrowRange = (now = moment()) => {
  const arrival = startOfDay(now).add(1, 'day');
  return { arrivalDate: arrival, departureDate: arrival.clone().add(1, 'day') };
};

export const rangesMatch = (a, b) => (
  !!a && !!b
    && !!a.arrivalDate && !!b.arrivalDate
    && !!a.departureDate && !!b.departureDate
    && a.arrivalDate.isSame(b.arrivalDate, 'day')
    && a.departureDate.isSame(b.departureDate, 'day')
);
